import React from "react";
import {
    Form,
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    List
} from "reactstrap";
import { useState, useEffect } from 'react';
import StyledButton from "../../components/Buttons/StyledButton";
import { SquareRadioButton, RadioDirection } from "../../components/Inputs/SquareRadioButton";
import { StaffPermissionsLevel } from '../../constants/localStorage';


const SetStaffPermissionsPage = ({ submitHandler, prevPage }) => {

    const level1AdminText = 'Only an Admin has full control over portal data, label creation, and more.'
    const level1PortalText = ['Managers can access training/help tools, view device information, and add prep lists by location.']
    const level1AppText = ['No access to make changes', 'No password required']
    const level2AdminText = 'Admin allows Managers to update menu item price and add staff at locations.'
    const level2PortalText = ['In addition to level 1, Managers can update retail price and add staff.']
    const level2AppText = ['Limited access to make changes', 'Password required']
    const level3AdminText = 'Admin relies fully on Managers to add and manage data in the portal.'
    const level3PortalText = ['In addition to level 2, Managers have full functionality access.', 'Admin can override Manager.'];
    const level3AppText = ['Can change portal pricing from app', 'Full access to make changes', 'Password required', 'Staff can reset passwords']

    const [manageData, setData] = useState(() => {
        const manageData = JSON.parse(localStorage.getItem(StaffPermissionsLevel));

        const isInteger = /^[0-9]\d*$/;

        return isInteger.test(manageData?.permissionSelected) ? manageData : { "permissionSelected": "1" };
    });

    useEffect(() => {
        if (manageData) {
            localStorage.setItem(StaffPermissionsLevel, JSON.stringify(manageData));
        }

    }, [manageData]);

    const handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        setData({ ...manageData, [name]: target.value })
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        submitHandler();
    }

    const PermissionSelection = ({ headerColor, level, description, portalText, appText, value }) => {
        const styles = {
            standard: {
                borderRadius: '0px',
                border: '2px solid var(--base-color-dark-blue)',
                borderBottom: '10px solid var(--base-color-dark-blue)',
                color: 'var(--base-color-dark-blue)',
                fontSize: '15px'
            },
            headerStyle: {
                backgroundColor: headerColor,
                borderRadius: '0px',
                height: '60px',
                color: 'var(--base-color-dark-blue)'
            },
            description: {
                height: '115px',
                backgroundColor: "var(--base-color-gray-background)",
                fontSize: '17px',
                fontWeight: 600
            },
            content: {
                height: '300px',
            },
            titleText: {
                fontSize: '40px',
                fontWeight: 600,
                color: "var(--base-color-dark-green)"
            },
            bodyTitleText: {
                fontSize: '20px',
                fontWeight: 600
            },
            listItem: {
                lineHeight: '12px'
            }

        }
        return (
            <SquareRadioButton
                value={value}
                valueChangeHandler={handleInputChange}
                initialValue={manageData.permissionSelected}
                direction={RadioDirection.Bottom}
                name="permissionSelected"
            >
                <Col className="d-flex align-items-center">
                    <Card style={styles.standard} className="d-flex">
                        <CardHeader style={styles.headerStyle} className="d-flex align-items-center justify-content-center text-center" >
                            <span style={styles.titleText}>LEVEL {level}</span>
                        </CardHeader>
                        <CardBody className="align-self-center text-center pt-2" style={styles.description}>
                            <div className="">{description}</div>
                        </CardBody>
                        <CardBody className="d-flex flex-column text-center pt-1" style={styles.content}>
                            <span style={styles.bodyTitleText}>Portal</span>
                            <List className="w-100 px-3">
                                {portalText.map((item) => {
                                    return (
                                        <div key={item}>
                                            <span className="pl-0" >&bull; {item}</span>
                                            <br />
                                        </div>
                                    )
                                }
                                )}
                            </List>
                            <span style={styles.bodyTitleText}>App</span>
                            <List className="w-100 px-3">
                                {appText.map((item, index) => {
                                    return (
                                        <div key={item}>
                                            <span className="pl-0">&bull; {item}</span>
                                            <br />
                                        </div >
                                    )
                                }
                                )}
                            </List >
                        </CardBody>
                    </Card>
                </Col>
            </SquareRadioButton>
        )
    }

    return (
        <div >
            <Container fluid={true}>
                    <Row style={{ height: 40 }}>
                        <Col className="h-100" />
                        <Col className="d-flex justify-content-center h-100">
                            <h2 className="d-flex text-center">Set Staff Permissions</h2> 
                        </Col>
                        <Col className="d-flex justify-content-end h-100 pr-5">
                            <StyledButton style={{ fontSize: ".9em" }} backgroundColor="var(--base-color-gray-background)" className="align-middle" height={30} width={190} textColor="var(--base-color-dark-blue)" text="View User Roles" onClick={() => document.getElementById("userRoles").scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })} />
                        </Col>
                    </Row>
                    <h4 className="text-center mb-4">Pick which level fits your business workflow. You can always adjust this later from your portal.</h4> 
                <Form className="container-fluid" onSubmit={handleSubmit} >
                    <Row>
                        <Col className="d-flex">
                            <PermissionSelection headerColor='var(--base-color-Salmon)' level={1} description={level1AdminText} portalText={level1PortalText} appText={level1AppText} value="1" />
                        </Col>
                        <Col className="d-flex" >
                            <PermissionSelection headerColor='#bfbdbf' level={2} description={level2AdminText} portalText={level2PortalText} appText={level2AppText} value="2" />
                        </Col>
                        <Col className="d-flex" >
                            <PermissionSelection headerColor='var(--base-color-light-green)' level={3} description={level3AdminText} portalText={level3PortalText} appText={level3AppText} value="3" />
                        </Col>
                    </Row>
                    <Row className="justify-content-center mt-5">
                        <Col className="onboarding-nav-btn d-flex justify-content-end h-100 pr-5">
                            <StyledButton onClick={prevPage} width="120px" height = "27px" text="Back" />
                        </Col>
                        <Col className="onboarding-nav-btn d-flex justify-content-start h-100 pr-3">
                            <StyledButton submitHandler={submitHandler} width="120px" height = "27px" text="Set Permissions" />
                        </Col>
                    </Row>
                </Form>
                <Card className="mt-5 mx-5" id="userRoles">
                    <CardHeader className="text-center" style={{ backgroundColor: 'var(--base-color-gray-background)' }}>
                        <span className="h2"><b>DateCodeGenie</b> User Types</span>
                    </CardHeader>
                    <CardBody className="">
                        <p><span className="font-weight-bold">Portal Administrators: </span><span> The person at a company responsible for setting up the portal, adding and managing data, and training to become the DataCodeGenie expert.</span></p>
                        <p><span className="font-weight-bold">Portal Managers: </span><span>A user with access to the portal and app. This person is generally responsible for training app users and may have control over many features based on permission settings.</span> </p>
                        <p><span className="font-weight-bold">App Users: </span><span> A user with access to the app only, with varying permissions available. Generally, they will only be printing labels.</span> </p>
                    </CardBody>
                </Card>
            </Container>
        </div>
    )

}

export default SetStaffPermissionsPage;